module.exports = __webpack_public_path__ + "img/08848231003853.712361d0.png";